import React, { createContext, useContext, useState, useEffect } from 'react';
import { client } from '../client';
import { userQuery } from '../utils/data';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const isGuest = user?.guest === true;

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);

      if (parsedUser.guest) {
        setUser(parsedUser);
        setLoading(false);
      } else {
        client.fetch(userQuery(parsedUser._id))
          .then((data) => {
            if (data && data.length > 0) {
              setUser(data[0]);
            } else {
              setUser(null);
              localStorage.removeItem('user');
            }
            setLoading(false);
          })
          .catch(() => {
            setUser(null);
            localStorage.removeItem('user');
            setLoading(false);
          });
      }
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, loading, isGuest }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
